export enum EWidgetSection {
  leftPrimary = 'left-primary',
  center = 'center',
  rightPrimary = 'right-primary',
}
